import { User } from "src/types/user";

export const getFullName = (user: User | null | undefined) => {
  if (!user) return "";
  return `${user.firstName} ${user.lastName}`;
};
